export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
                  随时随地 · 掌上吃瓜
                </h2>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                  黑料在线移动端页面已全面优化，暴走黑料在线观看和黑料社在线观看均可通过手机浏览器直接访问。
                  无需下载安装，即开即用，流量消耗低，加载速度快。将本站添加到手机桌面，即可像APP一样快速打开，
                  随时随地掌握最新黑料动态。
                </p>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
                  <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-colors">
                    <i className="ri-apple-fill text-xl text-foreground-600"></i>
                    <div>
                      <div className="text-[10px] text-foreground-400">iOS 用户</div>
                      <div className="text-xs font-semibold text-foreground-700 whitespace-nowrap">添加到桌面</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-colors">
                    <i className="ri-android-fill text-xl text-foreground-600"></i>
                    <div>
                      <div className="text-[10px] text-foreground-400">Android 用户</div>
                      <div className="text-xs font-semibold text-foreground-700 whitespace-nowrap">添加到桌面</div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-center lg:justify-start gap-3 mt-4">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-qr-scan-line text-primary-500"></i>
                    扫码访问
                  </div>
                  <span className="text-xs text-foreground-400">或</span>
                  <span className="text-xs text-primary-500 cursor-pointer hover:underline whitespace-nowrap">
                    直接浏览器打开
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="w-40 h-40 md:w-48 md:h-48 flex items-center justify-center rounded-2xl bg-background-100 border-2 border-background-200/60 border-dashed">
                  <div className="text-center">
                    <i className="ri-smartphone-line text-4xl text-foreground-400"></i>
                    <p className="mt-2 text-xs text-foreground-400">扫码访问</p>
                    <p className="text-[10px] text-foreground-300 mt-1">黑料在线移动版</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}